import useLocales from './useLocales';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useClientIdRedirect, buildIdentitySettings } from '@gsgroup/gsgroup-react-ui';
import { getIdentityClientSettings } from '../utils/localStorage';
import { getLoginFlowAsync } from '../apiClients/UserInfoClient';
import createCompanySpecificUserManager from '../utils/userManagerHelper';
import { BackendData } from './useBackendData';
import { setClientOptions } from '../utils/backendDataHelper';

export function useOidcClientLogin() {
  const navigate = useNavigate();
  const { translate } = useLocales();
  const { enqueueSnackbar } = useSnackbar();
  const baseSettings = getIdentityClientSettings();

  async function validateClientId(id: string) {
    const policyName = await getLoginFlowAsync(id);
    const settings = buildIdentitySettings(baseSettings, policyName);
    const userManager = createCompanySpecificUserManager(settings);
    const user = await userManager.getUser();

    if (!user || user.expired) {
      const clientOption: BackendData = { backendName: 0, name: id, tenantId: null };
      setClientOptions([clientOption]);
      await userManager.signinRedirect();
    } else {
      enqueueSnackbar(translate('ClientSelector.AlreadyLoggedIn'), { variant: 'info' });
      navigate("/");
    }
  }

  const { clientId: existingClientId, handleSubmit } = useClientIdRedirect({
    validateClientId,
    isInvalidClientErr: err => {
      const invalid = err instanceof Error && err.message === 'INVALID_CLIENT';
      if (invalid) {
        enqueueSnackbar(translate('ClientSelector.InvalidClientId'), { variant: 'error' });
      }
      return invalid;
    },
    resetPath: '/admin'
  });

  return { existingClientId, handleSubmit };
}